module.exports = __webpack_public_path__ + "static/media/company.18a50c26.png";